import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserLoginService } from 'src/app/shared/services/user-login.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-delete-account-success',
  templateUrl: './delete-account-success.component.html',
  styleUrls: ['./delete-account-success.component.scss'],
})
export class DeleteAccountSuccessComponent {
  @Input() dialogRef?: any;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  constructor(
    private userService: UserLoginService,
    private stateManagementService: StateManagementService,
    private localizationService: LocalizationService
  ) {
    this.localizationService.setupLocalization();
  }

  closeDialog(): void {
    this.stateManagementService.updateLoggedIn(false);
    this.dialogRef?.close(false);
    this.userService.logoutLocally();
  }
}
